import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import React from 'react';
export class ImageContextMenuItem extends React.Component {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.onClick = () => {
            const item = this.props.item;
            if (!isNullOrUndefined(item.event)) {
                item.event(item);
            }
            this.props.onCloseContextMenu();
        };
        this.onPointerEnter = () => {
            if (isValidString(this.props.item.tooltip)) {
                showTooltip(this.ref.current, Resources.getResource(this.props.item.tooltip));
            }
        };
        this.onPointerLeave = () => {
            if (isValidString(this.props.item.tooltip)) {
                hideTooltip();
            }
        };
    }
    render() {
        const activeStyle = this.props.item.selected ? ' _active' : '';
        const disabledStyle = this.props.item.enabled === false ? ' _disabled' : '';
        return (_jsx("div", { className: `new-context-menu-row${activeStyle}${disabledStyle}`, ref: this.ref, onClick: this.onClick, onPointerEnter: this.onPointerEnter, onPointerLeave: this.onPointerLeave, children: _jsx("div", { className: "new-context-menu-item", children: _jsx("div", { className: "new-context-menu-item-image", children: _jsx("svg", { children: _jsx("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${this.props.item.svgImage}` }) }) }) }) }));
    }
}
